import * as React from "react";

import {
  Button,
  DatePicker,
  Drawer,
  Empty,
  notification,
  Timeline,
} from "antd";
import { CommandBar, MessageBar, ProgressIndicator } from "@fluentui/react";
import { ChevronsDown, ChevronsUp, Send, ZoomIn } from "react-feather";
import { ClockCircleOutlined } from "@ant-design/icons";
import { Observer, observer } from "mobx-react-lite";
import MaterialStore from "../store/materialstore";
import { toJS } from "mobx";
import moment from "moment";
import "../style/stockhistorylist.css";
import formatNumber from "accounting-js/lib/formatNumber";
import exportFromJSON from "export-from-json";
import { getPickerDate } from "../../../Utility/modules/datePicker";
const _ = require("underscore");
const materialStoreCtx = React.createContext(MaterialStore);
const { RangePicker } = DatePicker;
export const StockHistoryList = observer(() => {
  const materialStore = React.useContext(materialStoreCtx);
  const item = materialStore.selChem;
  const TimelineItems = () => {
    const historyItems = [...materialStore.stockHistory.values()].map((x) =>
      toJS(x)
    );

    return historyItems.map((h) => (
      <Timeline.Item>
        <div
          className="ms-Grid"
          dir="ltr"
          style={{ backgroundColor: "#FFF4CE", padding: "5px" }}
        >
          <div className="ms-Grid-row">
            <div
              className="ms-Grid-col ms-sm12 history-span"
              style={{
                display: "flex",
                color: "red",
                justifyContent: "center",
                fontWeight: "bold",
              }}
            >
              {moment(h.changeDate).format("DD MMMM YYYY")} {h.restockTime}
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <div className="ms-Grid-col ms-sm3 history-span">
                <span style={{ fontWeight: "bold" }}>Stock: </span>
                <span>
                  {formatNumber(h.currentStock, {
                    precision: 2,
                    thousand: ",",
                  })}
                  {item.unitAbbr}
                </span>
              </div>
              <div className="ms-Grid-col ms-sm5 history-span">
                <span style={{ fontWeight: "bold" }}>Restock: </span>{" "}
                {Number(h.change) > 0 ? (
                  <ChevronsUp color="green" size="16" />
                ) : (
                  <ChevronsDown color="red" size="16" />
                )}{" "}
                <span>
                  {formatNumber(h.change, {
                    precision: 2,
                    thousand: ",",
                  })}
                  {item.unitAbbr}s
                </span>
              </div>
              <div className="ms-Grid-col ms-sm4 history-span">
                <span style={{ fontWeight: "bold" }}>Total: </span>
                <span>
                  {formatNumber(Number(h.change) + Number(h.currentStock), {
                    precision: 2,
                    thousand: ",",
                  })}
                  {item.unitAbbr}s
                </span>
              </div>
            </div>
          </div>
          {Number(h.cost) > 0 && (
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12 history-span">
                <span style={{ fontWeight: "bold" }}>Cost: </span>
                <span>
                  NGN
                  {formatNumber(h.cost, {
                    precision: 2,
                    thousand: ",",
                  })}
                </span>
              </div>
            </div>
          )}

          <div className="ms-Grid-row history-span">
            <div className="ms-Grid-col ms-sm6">
              <span style={{ fontWeight: "bold" }}>Action Party: </span>
              <span>{_.isEmpty(h.restockParty) ? "N/A" : h.restockParty}</span>
            </div>
            <div className="ms-Grid-col ms-sm6 history-span">
              <span style={{ fontWeight: "bold" }}>Approver: </span>
              <span>
                {_.isEmpty(h.approvedParty) ? "N/A" : h.approvedParty}
              </span>
            </div>
          </div>
          <div className="ms-Grid-row history-span">
            <div className="ms-Grid-col ms-sm12">
              <span style={{ fontWeight: "bold" }}>Vendor: </span>
              <span>{_.isEmpty(h.vendor) ? "N/A" : h.vendor}</span>
            </div>
          </div>
          <div className="ms-Grid-row history-span">
            <div className="ms-Grid-col ms-sm12">
              <span style={{ fontWeight: "bold" }}>Remarks: </span>
              <span>{_.isEmpty(h.remarks) ? "N/A" : h.remarks}</span>
            </div>
          </div>
        </div>
      </Timeline.Item>
    ));
  };

  const fileName = `${item?.name} download`;
  const exportType = "csv";
  return (
    <Drawer
      title={` ${materialStore.mainStore.assetContextName}'s  ${materialStore.selChem?.name} Restock History`}
      visible={materialStore.showHistoryDialog}
      destroyOnClose={true}
      onClose={() => {
        materialStore.showHistoryDialog = false;
      }}
      width={"600px"}
    >
      <CommandBar
        farItems={[
          {
            key: "newItem",
            text: "Export to Excel",
            cacheKey: "myCacheKey", // changing this key will invalidate this item's cache

            onRenderIcon: () => <Send />,
            onClick: async () => {
              const data = [...materialStore.stockHistory.values()].map((x) =>
                _.pick(
                  toJS(x),
                  "currentStock",
                  "change",
                  "cost",
                  "changeDate",
                  "restockTime",
                  "approvedParty",
                  "restockParty",
                  "vendor",
                  "remarks",
                  "uploadedBy",
                  "uploadedOn"
                )
              );
              await exportFromJSON({ data, fileName, exportType });
            },
          },
        ]}
        ariaLabel="Use left and right arrow keys to navigate between commands"
      />
      <div className="ms-Grid" dir="ltr" style={{ paddingTop: "5px" }}>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            {" "}
            <MessageBar>
              Filter audit history by start period and end period
            </MessageBar>
          </div>
        </div>
        <div className="ms-Grid-row" style={{ paddingTop: "5px" }}>
          <div
            className="ms-Grid-col ms-sm3"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            Filter Range:
          </div>{" "}
          <div className="ms-Grid-col ms-sm9">
            {" "}
            <RangePicker
              style={{ width: "100%" }}
              onChange={async (date, dateString) => {
                if (date) {
                  let [startDate, endDate] = date;

                  try {
                    const start = moment(getPickerDate(startDate)).format(
                      "YYYY-MM-DDT00:00:00.000Z"
                    );
                    const end = moment(getPickerDate(endDate)).format(
                      "YYYY-MM-DDT00:00:00.000Z"
                    );

                    await materialStore.filterRange(start, end);
                  } catch (error) {
                    notification.error({
                      key: "error",
                      message: "SPARS Feedback",
                      description: error.message,
                    });
                  }
                } else {
                  try {
                    materialStore.isfiltering = true;

                    await materialStore.loadStockHistory(item);
                    materialStore.showHistoryDialog = true;
                  } catch (error) {
                    notification.error({
                      key: "error",
                      message: "SPARS Feedback",
                      description: error.message,
                    });
                  } finally {
                    materialStore.isfiltering = false;
                  }
                }
              }}
            />
            {materialStore.isfiltering && (
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  {" "}
                  <ProgressIndicator
                    description="processing, please wait..."
                    styles={{ root: { textAlign: "center" } }}
                  ></ProgressIndicator>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="ms-Grid-row">
        <div
          className="ms-Grid-col ms-sm12"
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            paddingTop: "30px",
          }}
        >
          {[...materialStore.stockHistory.values()].length > 0 ? (
            <Timeline style={{ width: "600px" }}>
              <Observer>{TimelineItems}</Observer>
            </Timeline>
          ) : (
            <Empty description="No History"></Empty>
          )}
        </div>
      </div>
    </Drawer>
  );
});

